import { render, staticRenderFns } from "./layout2.vue?vue&type=template&id=c407b9cc&scoped=true&"
import script from "./layout2.vue?vue&type=script&lang=js&"
export * from "./layout2.vue?vue&type=script&lang=js&"
import style1 from "./layout2.vue?vue&type=style&index=1&id=c407b9cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c407b9cc",
  null
  
)

export default component.exports